module.exports = __webpack_public_path__ + "img/p2-94.48cfc7f0.png";